import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "d-flex align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "ml-auto d-flex align-items-center"
}
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_7 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_8 = { class: "text-danger" }
const _hoisted_9 = {
  key: 1,
  class: "py-5 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DeviceItem = _resolveComponent("DeviceItem")
  const _component_DialogAddEditGate = _resolveComponent("DialogAddEditGate")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.currentGate?.name), 1)
        ]),
        (!_ctx.adminView && !_ctx.currentEntrancePlant.syncStatus?.isPlantActive)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_ElDropdown, {
                trigger: "click",
                placement: "bottom-end",
                "popper-class": "el-dropdown__popper el-dropdown--context"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleConfigureGateDialog }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_6, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteGateConfirm }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_7, [
                            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Button, { class: "p-button-text p-button-secondary p-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InlineSvgScoped, {
                        src: require('@/assets/images/icons/icon-ellipsis-v.svg'),
                        "aria-label": "icon-ellipsis-v"
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.hasDevices)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.gateDevices, (device) => {
          return (_openBlock(), _createBlock(_component_DeviceItem, {
            key: device.deviceId,
            device: device,
            class: "mt-3"
          }, null, 8, ["device"]))
        }), 128))
      : (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("h1", null, _toDisplayString(_ctx.$t("entrancePlant.gatesDetailNoDevices")), 1)
        ])),
    _createVNode(_component_DialogAddEditGate, {
      isVisible: _ctx.isVisibleDialogConfigureGate,
      gateToEdit: _ctx.currentGate,
      onHideDialog: _ctx.toggleConfigureGateDialog,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "gateToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogConfirmDelete, {
      title: _ctx.$t('entrancePlant.deleteGateTitle'),
      message: _ctx.$t('entrancePlant.deleteGateMessage'),
      isVisible: _ctx.isVisibleDeleteGateConfirm,
      onHideDialog: _ctx.toggleDeleteGateConfirm,
      onConfirm: _ctx.deleteGate
    }, null, 8, ["title", "message", "isVisible", "onHideDialog", "onConfirm"])
  ], 64))
}